import styled from "@emotion/styled";
import { IconButton } from '@fluentui/react';
import React from "react";

export const getDatePickerClearSuffix = (
  value: Date | null | any,
  setValue: (value: Date | null) => void
) => () => {
  if (value !== null && value !== undefined && value !== "") {
    return (
      <StyledIconButton
        iconProps={{
          iconName: "ChromeClose"
        }}
        onMouseDown={() => setValue(null)}
      />
    );
  }
  return null;
};

const StyledIconButton = styled(IconButton)`
  cursor: auto;
  &:hover {
    background: transparent;
  }
  .ms-Icon.ms-Icon {
    font-size: 11px;
    color: #ababab;
  }
`;
